<div
  class="relative flex flex-col w-full space-y-1 h-11 max-h-11"
  nrcClickOutside
  [excludeQuerySelector]="['.nrc-input-nested-select-menu', '.nrc-input-nested-select-root']"
  (clickOutsideEvent)="closeOptions()"
>
  <div
    #selectInputElement
    class="flex flex-col items-stretch justify-center h-full cursor-pointer"
    [ngClass]="{
      'rounded-[100px]': isRound,
      'bg-neutral-900 shadow': !isTransparent,
      'bg-transparent' : isTransparent,
      'border-b-1 border-b-gray-700 rounded-t': !isRound && !isTransparent,
      'opacity-50 select-none pointer-events-none': disabled
    }"
    tabindex="0"
    (click)="toggleShowOptions()"
    (keyup)="null"
  >
    @if (label) {
      <span
        class="ml-4 mt-0.5 text-xxs"
        [ngClass]="{
          'text-error' : formControl.touched && formControl.invalid,
          'text-cyan': showOptions() && !(formControl.touched && formControl.invalid),
          'text-gray-400': !showOptions() && !(formControl.touched && formControl.invalid)
        }"
      >{{ label }}</span>
    }

    <div
      class="flex items-center justify-between"
      [ngClass]="{
        'pb-1.5': !isRound,
        'px-4': !fitContent
      }"
    >
      <input
        #inputElement
        type="text"
        class="w-full h-5 p-0 text-sm bg-transparent border-transparent outline-none focus:border-transparent focus:outline-none placeholder:text-white/70 focus:ring-0"
        [value]="getDisplayValue()"
        [placeholder]="placeholder"
        [readonly]="true"
        [disabled]="disabled || false"
      />

      <nrc-icon
        class="w-4 h-4"
        [ngClass]="{
          'pb-2': !isRound && !isTransparent,
          'pb-1': isTransparent
        }"
        [name]="'select'"
        [classList]="showOptions() ? ['transition-transform', 'rotate-180'] : ['transition-transform']"
      />
    </div>
  </div>

  @if (showOptions()) {
    <div
      [nrcOverlayPortal]="selectInputElement"
      [overflowParent]="overflowParentElement"
      [offset]="isRound ? 24 : 4"
      [matchWidth]="true"
      class="nrc-input-nested-select-root z-[10000] w-full min-w-48 rounded-md bg-neutral-900 shadow overflow-visible"
    >
      <div class="max-h-48 overflow-y-auto overflow-x-visible">
        <ng-container
          [ngTemplateOutlet]="optionsTemplate"
          [ngTemplateOutletContext]="{ $implicit: normalizedOptions, path: [], level: 0 }"
        />
      </div>
    </div>
  }
</div>

@for (menu of openMenus(); let level = $index; track level) {
  <div
    nrcMenuPosition="right-preferred"
    [triggerElement]="menu.triggerElement"
    [menuWidth]="192"
    [offset]="6"
    [nrcOverlayPortal]="menu.triggerElement"
    [portalOnly]="true"
    class="nrc-input-nested-select-menu min-w-48 rounded-md bg-neutral-900 shadow overflow-visible"
  >
    <div class="max-h-48 overflow-y-auto overflow-x-visible">
      <ng-container
        [ngTemplateOutlet]="optionsTemplate"
        [ngTemplateOutletContext]="{ $implicit: menu.option.children, path: menu.path, level: level + 1 }"
      />
    </div>
  </div>
}

<ng-template #optionsTemplate let-options let-path="path" let-level="level">
  @if (!options || options.length === 0) {
    <span class="flex p-4 text-sm cursor-pointer transition-all duration-250 ease-in-out">
      No results found
    </span>
  } @else {
    @for (option of options; track $index) {
      <div class="relative">
        <button
          type="button"
          class="flex items-center justify-between w-full text-xs/[14px] text-[#f8f8f8] transition-[color] duration-250 ease-in-out px-4 py-2 cursor-pointer hover:bg-white/5"
          (click)="handleOptionClick(option, buildPath(path, option), $event, level)"
        >
          <span class="truncate">{{ option.label }}</span>
          @if (option.children.length > 0) {
            <nrc-icon class="w-3 h-3 -rotate-90" [name]="'select'" />
          }
        </button>
      </div>
    }
  }
</ng-template>
